import { Chart } from './Chart'
import type { ApexOptions } from 'apexcharts'
import useReview from '@/composables/review'
const { tooltipAreaChartContent } = useReview()

class AnalyticsAreaChart extends Chart {
  options = {
    ...this.options,
    chart: {
      ...this.options.chart,
      type: 'area',
      zoom: {
        enabled: false
      }
    },
    tooltip: {
      followCursor: true,
      custom: function ({ series, seriesIndex, dataPointIndex, w }) {
        const seriesData = w.globals.initialSeries[seriesIndex]
        return tooltipAreaChartContent(
          seriesData.data[dataPointIndex].x,
          seriesData.name,
          series[seriesIndex][dataPointIndex]
        )
      }
    },
    colors: [],
    series: [],
    stroke: {
      curve: 'straight'
    },
    xaxis: {
      axisTicks: {
        show: false
      },
      tooltip: {
        enabled: false
      }
    },
    yaxis: {
      labels: {
        show: true,
        style: {
          colors: [],
          fontSize: '12px',
          cssClass: 'opacity-40'
        },
        formatter: function (value) {
          return value.toString()
        },
        offsetX: -5
      }
    },
    dataLabels: {
      enabled: true
    },
    fill: {
      type: 'gradient',
      gradient: {
        shadeIntensity: 0.5,
        opacityFrom: 0.6,
        opacityTo: 0
      }
    }
  } as ApexOptions

  setSeries(series: Array<{ name: string; data: [] }>): void {
    this.options.series = series
  }

  setColor(color: string[]): void {
    this.options.colors = color
  }

  setCategories(categories: string[]): void {
    this.options = {
      ...this.options,
      ...{
        xaxis: {
          ...this.options.xaxis,
          categories: categories
        }
      }
    }
  }
}

export { AnalyticsAreaChart }
